module.exports = __webpack_public_path__ + "img/gateway.c58cde6b.png";